import { call, takeLatest, select, put, delay, take, fork, cancel } from 'redux-saga/effects';
import { Task } from 'redux-saga';
import { AxiosResponse } from 'axios';
import { IUser, makeBackendApi } from 'services/BackendApi';
import { selectedTaSelector } from '../../agents';
import { GET_FILTER_INFO_REQUEST, GET_USERS_REQUEST, getFilterInfoFailureAction, getFilterInfoSuccessAction, getUsersFailureAction, GetUsersRequestAction, getUsersSuccessAction, TTaskUserListType } from '../actions';
import { enqueueNotification } from 'store/modules/ui';
import { makeTaskManagementApi } from 'services/TaskManagementApi/TaskManagementApi';

export function* getFilterInfoSaga() {
  yield delay(1000);

  try {
    const taskManagementApi = makeTaskManagementApi();
    const taskCategories: AxiosResponse<any> = yield call(taskManagementApi.getTaskCategoriesInfo);
    const taskTeams: AxiosResponse<any> = yield call(taskManagementApi.getTaskTeamsInfo);

    yield put(getFilterInfoSuccessAction(taskCategories.data, taskTeams.data));
  } catch (e) {
    yield put(getFilterInfoFailureAction(e));
    yield put(enqueueNotification({ message: 'Can not get filter information', options: { variant: 'error' } }));
  }
}

export function* searchUsersSimpleSaga(action: GetUsersRequestAction) {
  yield delay(700);
  try {
    const selectedTa = yield select(selectedTaSelector);
    const backendApi = makeBackendApi(selectedTa?.uuid);
    const taskUsers: AxiosResponse<{ data: Pick<IUser, 'uuid' | 'firstName' | 'lastName' | 'email'>[] }> = yield call(backendApi.searchUsersSimple, action.filterTerm, 'firstName');

    yield put(getUsersSuccessAction(taskUsers.data.data, action.typeOfUser));
  } catch (e) {
    yield put(getUsersFailureAction(e, action.typeOfUser));
    yield put(enqueueNotification({ message: 'Can not get users', options: { variant: 'error' } }));
  }
}

// takeLatest per dropdown: the task forms load assignees and reviewers together on mount, and a
// single takeLatest would cancel one of them and leave its request PENDING for good.
export function* takeLatestUsersSearchPerType() {
  const running: Partial<Record<TTaskUserListType, Task>> = {};
  while (true) {
    const action: GetUsersRequestAction = yield take(GET_USERS_REQUEST);
    const previous = running[action.typeOfUser];
    if (previous) {
      yield cancel(previous);
    }
    running[action.typeOfUser] = yield fork(searchUsersSimpleSaga, action);
  }
}

export function* watchGetFilterInfoSaga() {
  yield fork(takeLatestUsersSearchPerType);
  yield takeLatest(
    GET_FILTER_INFO_REQUEST,
    getFilterInfoSaga
  );
}
